module.exports = __webpack_public_path__ + "static/slide-2-213f86302eddd277b6b0c87ebf967f59.jpg";